export type OnboardingStep = 'website-spend' | 'book-demo' | 'plan-payment'

export const mapStepToV2 = (
	setupStep: string | undefined,
	isAgency: boolean,
	spend: number,
	scheduledDemo?: boolean | null,
	isNewWorkspace?: boolean,
	isPersonalEmail = false
): OnboardingStep => {
	if (!setupStep || setupStep === 'workspace') return 'website-spend'

	// Agency OR spend >= $10k → show demo booking (unless already booked/skipped)
	if (
		(setupStep === 'ACCOUNT_CREATED' || setupStep === 'PLAN_SELECTED') &&
		!isPersonalEmail &&
		(isAgency || spend >= 10000) &&
		scheduledDemo == null &&
		!isNewWorkspace
	) {
		return 'book-demo'
	}

	if (
		setupStep === 'ACCOUNT_CREATED' ||
		setupStep === 'PLAN_SELECTED' ||
		setupStep === 'activation'
	) {
		return 'plan-payment'
	}

	return 'website-spend'
}
